module.exports = __webpack_public_path__ + "media/images/flags/32/Kuwait-d716cde2231e0acdb025f8c3ea814eec.png";